






























import { Component } from "vue-property-decorator";
import { email, required } from "vuelidate/lib/validators";
import { Validate } from "vuelidate-property-decorators";
import { mixins } from "vue-class-component";
import NotificationEvent from "@/resources/mixins/notifications/notificationEvent";
import { i18n } from "@/resources/locales";
import ErrorController from "@/resources/mixins/errorController/errorController";
import { URL_CHECK } from "@/resources/constants/urlCheck";
@Component({})
export default class ForgotPasswordComponent extends mixins(
  NotificationEvent,
  ErrorController
) {
  @Validate({ required, email })
  email = "";
  loading = false;

  onSendRequestPassword(): void {
    this.loading = true;
    this.$store.dispatch("AuthStore/requestPasswordAction", {
      data: { 
        email: this.email,
        domain: this.checkDomain()
      },
      callback: (response) => {
        this.loading = false;
        let message = "";
        if (response.data.includes("recovering"))
          message = "notifications.descriptions.recoveringPassword";
        else if (response.data.includes("registered"))
          message = "notifications.descriptions.emailNotRegistered";
        else if (response.data.includes("requesting"))
          message = "notifications.descriptions.waitSendRecoveryPassword";
        this.onSuccess("", i18n.t(message));
        this.email = "";
        this.$router.push("auth/login");
      },
      callbackError: (error) => {
        this.loading = false;
        if (error.response && error.response.status == 401)
          this.checkError(error);
        else
          this.onError(
            "",
            i18n.t("notifications.genericError.genericError", {
              code: error.response.status,
            })
          );
      },
    });
  }
  checkDomain(): string {
    URL_CHECK.forEach(element => {
      if (window.location.host.includes(element.url)) {
        return element.domain;
      }
    });
    return "DEFAULT";
  }
}
